import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "actionsBar", "count", "idsField"]

  connect() {
    // Defer to ensure all targets are available
    requestAnimationFrame(() => this.updateSelection())
  }

  toggleAll() {
    if (!this.hasSelectAllTarget) return
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateSelection()
  }

  updateSelection() {
    const selectedIds = this.selectedIds
    const count = selectedIds.length
    const total = this.checkboxTargets.length

    // Update count display
    if (this.hasCountTarget && this.countTarget) {
      this.countTarget.textContent = count
    }

    // Update hidden field with selected IDs
    if (this.hasIdsFieldTarget && this.idsFieldTarget) {
      this.idsFieldTarget.value = selectedIds.join(",")
    }

    // Show/hide actions bar
    if (this.hasActionsBarTarget && this.actionsBarTarget) {
      if (count > 0) {
        this.actionsBarTarget.classList.remove("hidden")
      } else {
        this.actionsBarTarget.classList.add("hidden")
      }
    }

    // Update select all checkbox state
    if (this.hasSelectAllTarget && this.selectAllTarget) {
      this.selectAllTarget.checked = count === total && total > 0
      this.selectAllTarget.indeterminate = count > 0 && count < total
    }
  }

  beforeSubmit(event) {
    // Ensure IDs are set right before form submission
    const selectedIds = this.selectedIds
    if (this.hasIdsFieldTarget && this.idsFieldTarget) {
      this.idsFieldTarget.value = selectedIds.join(",")
    }

    if (selectedIds.length === 0) {
      event.preventDefault()
      alert("No items selected")
    }
  }

  get selectedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }
}
